/* Swym Product Page button */

const swymObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        if (node.classList && node.classList.contains("swym-button-bar")) {
          const productGallery = document.querySelector(
            '.product product-gallery'
          );
          if (productGallery) {
            productGallery.appendChild(node);
            node.classList.add("loaded");
            swymObserver.disconnect();
          }
        }
      }
    });
  });
});

swymObserver.observe(document.body, {
  childList: true,
  subtree: true,
});


/* Swym Product Page button icon resize */
const svg = document.getElementById('swym-atw-pdp-button-icon');

if (svg && !svg.hasAttribute('viewBox')) {
  svg.setAttribute('viewBox', '0 0 24 24');
}

/* Swym Product Page button */

/* Global function for SearchSpring / Add to cart + drawer update */

// Utility to detect the dynamic Stretch section IDs for the cart
function getCartSectionIds() {
  const sections = [];
  document.querySelectorAll('[id^="shopify-section-"]').forEach(sec => {
    const id = sec.id.replace('shopify-section-', '');
    if (id.includes('cart-drawer') || id.includes('cart-icon-bubble')) {
      sections.push(id);
    }
  });
  return sections;
}

// Global function for Searchspring / custom triggers
window.addToCart = async function(variantId, quantity = 1) {
  try {
    const sections = getCartSectionIds();

    // Add item to cart
    const addResp = await fetch('/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity,
        sections: sections,
        sections_url: window.location.pathname
      })
    });

    const addData = await addResp.json();

    // Fetch full cart for item_count and totals
    const cart = await fetch('/cart.js').then(r => r.json());

    // Build cartContent like Stretch theme expects
    const cartContent = { sections: addData.sections, cart };

    // Prepare items array like theme
    const items = addData.hasOwnProperty("items") ? addData.items : [addData];

    // Dispatch variant:add event for internal theme listeners
    document.dispatchEvent(new CustomEvent("variant:add", {
      bubbles: true,
      detail: { items, cart: cartContent }
    }));

    // Dispatch cart:change event for drawer, badge, etc.
    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: { baseEvent: "variant:add", cart: cartContent }
    }));

    // Safely open the cart drawer by triggering the toggle button
    const cartButton = document.querySelector('[data-action="toggle-cart"]');
    if (cartButton) cartButton.click();

  } catch (err) {
    console.error("addToCart error:", err);

    // Dispatch cart:error for theme listeners
    document.dispatchEvent(new CustomEvent("cart:error", {
      bubbles: true,
      detail: { error: err.message }
    }));

    // Trigger cart:refresh as fallback
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
  }
};

/* End of Global function for SearchSpring / Add to cart + drawer update */

/* Pre-order checkout confirmation modal */
(() => {
  const PREORDER_MODAL_ID = 'preorder-checkout-modal';
  let pendingForm = null;
  let pendingSubmitter = null;
  let isRemovingPreorder = false;

  function cartHasPreorder(form) {
    if (!form) {
      return false;
    }

    return form.getAttribute('data-has-preorder') === 'true';
  }

  function getPreorderModal() {
    return document.getElementById(PREORDER_MODAL_ID);
  }

  function openPreorderModal(form, submitter) {
    const modal = getPreorderModal();

    if (!modal || typeof modal.show !== 'function') {
      form.setAttribute('data-preorder-confirmed', 'true');
      submitCheckout(form, submitter);
      return;
    }

    pendingForm = form;
    pendingSubmitter = submitter;
    modal.show({ activator: submitter });
  }

  function closePreorderModal() {
    const modal = getPreorderModal();

    if (modal && typeof modal.hide === 'function') {
      modal.hide();
    }
  }

  function submitCheckout(form, submitter) {
    if (!form) {
      window.location.href = `${window.Shopify?.routes?.root || '/'}checkout`;
      return;
    }

    form.setAttribute('data-preorder-confirmed', 'true');

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(submitter || undefined);
      return;
    }

    form.submit();
  }

  function continueToCheckout() {
    const form = pendingForm;
    const submitter = pendingSubmitter;

    pendingForm = null;
    pendingSubmitter = null;
    closePreorderModal();
    submitCheckout(form, submitter);
  }

  function getCartSectionIds() {
    const sections = new Set();

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections },
      }),
    );

    return [...sections];
  }

  async function removePreorderItemsAndCheckout(button) {
    if (isRemovingPreorder) {
      return;
    }

    const modal = getPreorderModal();
    const lineKeys = [...(modal?.querySelectorAll('[data-preorder-line-key]') || [])]
      .map((el) => el.getAttribute('data-preorder-line-key'))
      .filter(Boolean);

    if (!lineKeys.length) {
      continueToCheckout();
      return;
    }

    isRemovingPreorder = true;
    button?.setAttribute('aria-busy', 'true');

    try {
      const updates = Object.fromEntries(lineKeys.map((key) => [key, 0]));
      const sections = getCartSectionIds();

      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          updates,
          sections: sections.join(','),
        }),
      });

      if (!response.ok) {
        throw new Error('Unable to remove pre-order items');
      }

      const cart = await response.json();

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'line-item:change',
            cart,
          },
        }),
      );

      pendingForm = null;
      pendingSubmitter = null;
      closePreorderModal();

      if (cart.item_count > 0) {
        window.location.href = `${window.Shopify.routes.root}checkout`;
        return;
      }

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true }),
      );
    } catch (error) {
      console.error(error);
      document.dispatchEvent(
        new CustomEvent('toast:show', {
          detail: {
            message: error.message || 'Unable to remove pre-order items',
            tone: 'error',
          },
        }),
      );
    } finally {
      isRemovingPreorder = false;
      button?.removeAttribute('aria-busy');
    }
  }

  // Only intercept after native HTML5 validation (terms checkbox, etc.) has passed.
  // Invalid forms never fire "submit", so the browser can show required-field errors first.
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) {
        return;
      }

      if (!cartHasPreorder(form) || form.getAttribute('data-preorder-confirmed') === 'true') {
        return;
      }

      const submitter = event.submitter;
      const isCheckout =
        submitter?.getAttribute?.('name') === 'checkout' ||
        Boolean(form.querySelector('[name="checkout"]'));

      if (!isCheckout) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      openPreorderModal(form, submitter || form.querySelector('[name="checkout"]'));
    },
    true,
  );

  document.addEventListener('click', (event) => {
    const continueButton = event.target.closest('.preorder-checkout-modal__continue');
    if (continueButton) {
      event.preventDefault();
      continueToCheckout();
      return;
    }

    const removeButton = event.target.closest('.preorder-checkout-modal__remove');
    if (removeButton) {
      event.preventDefault();
      removePreorderItemsAndCheckout(removeButton);
    }
  });
})();
